import { useCallback } from 'react';
import { commitLocalUpdate, useRelayEnvironment } from 'react-relay';
import type { SelectorStoreUpdater } from 'relay-runtime';
import {
	statusCategoryForId,
	DONE,
} from '@jira/platform__status-categories/src/status-categories.tsx';
import type { Options, StatusUpdateHandler } from '../types.tsx';

export function useCommitLocalUpdate(
	updater: SelectorStoreUpdater,
	{ isHideDoneEnabled }: Options,
) {
	const environment = useRelayEnvironment();

	return useCallback<StatusUpdateHandler>(
		(field) => {
			if (!isHideDoneEnabled) return;
			if (statusCategoryForId(field.statusCategory?.statusCategoryId) !== DONE) return;

			commitLocalUpdate(environment, updater);
		},
		[environment, isHideDoneEnabled, updater],
	);
}
